import { motion } from "framer-motion";
import { AppStoreBadge, GooglePlayBadge } from "@/components/StoreBadges";

export default function DownloadPage() {
  return (
    <div data-testid="download-page" className="flex min-h-screen items-center justify-center bg-[#0A0A0A] text-white">
      <section className="mx-auto flex w-full max-w-[1100px] flex-col items-center px-6 py-24 text-center">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="font-sans text-3xl font-medium tracking-tight text-[#3ED8D8] md:text-4xl"
        >
          Stronger Together
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
          className="mt-10 flex flex-wrap items-center justify-center gap-3"
        >
          <GooglePlayBadge />
          <AppStoreBadge />
        </motion.div>
      </section>
    </div>
  );
}
